<template>
  <div class="collect-select-type">
    <a-form-item :class="{'disabled-input': dis}">
      <a-select
        :default-value="itemData.fieldtype"
        :disabled="!itemData.ischangetype"
        class="collect-item-select"
        @change="handleChange"
      >
        <a-select-option
          v-if="itemData.fieldtype === 'email'"
          value="email"
          :label="inputPlaceholder"
        >
          {{ $t('message["1264"]') }}
        </a-select-option>
        <a-select-option value="text">
          {{ $t('message["1123"]') }}
        </a-select-option>
        <a-select-option
          value="ip"
          :label="ipAdress"
        >
          {{ ipAdress }}
        </a-select-option>
        <a-select-option value="editor">
          {{ $t('message["328"]') }}
        </a-select-option>
        <a-select-option value="tag">
          {{ $t('message["52"]') }}
        </a-select-option>
        <a-select-option value="select">
          {{ $t('message["1297"]') }}
        </a-select-option>
      </a-select>
      <span v-if="itemData.fieldtype === 'select'">
        <a
          href="javascript:;"
          @click="setOption"
        >{{ $t('message["1037"]') }}</a>
        <a-input
          v-decorator="!!itemData.isenable ? decorator : decorator2"
          type="hidden"
        />
        <set-option-input
          ref="setoption"
          :item-data="itemData"
          :clone-data="cloneData"
          @getHiddenVal="getHiddenVal"
        />
      </span>
    </a-form-item>
  </div>
</template>
<script>
import SetOptionInput from './SetOptionInput'
import { cloneDeep } from 'lodash'
export default {
  components: {
    SetOptionInput
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    parentIndex: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    dis: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultvalue: 'radio',
      cloneData: {},
      tipType: this.$t('message["150"]'),
      decorator: [
        `inputHidden_${this.parentIndex}_${this.index}_${this.itemData.id || this.itemData._id}`,
        {
          rules: [{ required: true, message: this.$t('message["1038"]') }],
          initialValue: this.itemData.options.join(',')
        }
      ],
      decorator2: [
        `inputHidden_${this.parentIndex}_${this.index}_${this.itemData.id || this.itemData._id}`,
        {
          initialValue: this.itemData.options.join(',')
        }
      ]
    }
  },
  computed: {
    inputPlaceholder () {
      return this.$t('message["1264"]')
    },
    ipAdress () {
      return this.$t('message["1714"]')
    }
  },
  inject: ['myForm'],
  methods: {
    handleChange (val) {
      this.itemData.fieldtype = val
    },
    setOption () {
      this.cloneData = cloneDeep(this.itemData)
      this.$refs.setoption.changeVisible(true)
    },
    getHiddenVal (val) {
      this.myForm.form.setFieldsValue({
        [`inputHidden_${this.parentIndex}_${this.index}_${this.itemData.id || this.itemData._id}`]: val
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .collect-select-type::v-deep {
    display: inline;
    .collect-item-select {
      margin-right: 16px;
      width: 240px;
    }
    .disabled-input  .has-error {
      .ant-select-selection {
        border-color: #d6d6d6;
      }
      .ant-select-arrow-icon {
        color: rgba(0, 0, 0, 0.25)
      }
      .ant-form-explain {
        display: none;
      }
    }
  }
</style>
